module.exports = __webpack_public_path__ + "static/media/Айсагалиев С., Корпебай Г.Т..0f41cada.pdf";